const rules = {
  ndisNativeApi: {
    static: [
      'participants-page:visit',
      'participants-360-view-page:visit',
      'service-bookings-page:visit',
      'integration-page:visit',
      'setting-page:visit',
      'ndis-notifications-page:visit',
      'registrations-page:visit',
    ],
  },
  free: {
    static: [
      'dashboard-page:visit',
      'participants-page:visit',
      'service-bookings-page:visit',
      'setting-page:visit',
      'registrations-page:visit',
      'financial-contact-page:visit',
      'participants-360-view-page:visit',
      'category-x-page:visit',
      'category-y-page:visit',
    ],
  },
  enterprise: {
    static: [
      'dashboard-page:visit',
      'participants-page:visit',
      'analytics-page:visit',
      'service-bookings-page:visit',
      'service-delivery-page:visit',
      'products-page:visit',
      'financial-contact-page:visit',
      'registrations-page:visit',
      'ready-to-claim-page:visit',
      'claim-management-page:visit',
      'claim-recovery-page:visit',
      'claims-in-error-page:visit',
      'claim-batch-history-page:visit',
      'claim-batch-detail-page:visit',
      'payment-cancellation-page:visit',
      'successful-claims-page:visit',
      'participant-consent-page:visit',
      'remittance-page:visit',
      'invoices-page:visit',
      'ready-to-invoice-page:visit',
      'issued-invoices-page:visit',
      'invoice-details-page:visit',
      'invoices-in-error-page:visit',
      'invoice-batch-history-page:visit',
      'participants-360-view-page:visit',
      'setting-page:visit',
      'roster-of-care-page:visit',
      'integration-page:visit',
      'ndis-notifications-page:visit',
      'budget-page:visit',
      'category-x-page:visit',
      'category-y-page:visit',
      'label-management-page:visit',
      'legal-entity-management-page:visit',
      'account-receivable-page:visit',
      'ar-payments-page:visit',
      'ar-invoices-page:visit',
      'ar-settlement-page:visit',
      'ar-invoice-details-v2-page:visit',
      'ar-invoice-batches-page:visit',
      'ar-payer-statements-page:visit',
      'ar-person-management-page:visit',
      'ar-person-details-page:visit',
      'transactions-page:visit',
      // 'posts:list',
      // 'posts:create',
      // 'posts:edit',
      // 'posts:delete',
      // 'users:get',
      // 'users:getSelf',
      // 'home-page:visit',
      // 'dashboard-page:visit',
    ],
  },
  enterprisePlusSAH: {
    static: [
      'dashboard-page:visit',
      'participants-page:visit',
      'analytics-page:visit',
      'service-bookings-page:visit',
      'service-delivery-page:visit',
      'products-page:visit',
      'financial-contact-page:visit',
      'registrations-page:visit',
      'ready-to-claim-page:visit',
      'claim-management-page:visit',
      'claim-recovery-page:visit',
      'claims-in-error-page:visit',
      'claim-batch-history-page:visit',
      'claim-batch-detail-page:visit',
      'payment-cancellation-page:visit',
      'successful-claims-page:visit',
      'participant-consent-page:visit',
      'remittance-page:visit',
      'invoices-page:visit',
      'ready-to-invoice-page:visit',
      'issued-invoices-page:visit',
      'invoice-details-page:visit',
      'invoices-in-error-page:visit',
      'invoice-batch-history-page:visit',
      'participants-360-view-page:visit',
      'setting-page:visit',
      'roster-of-care-page:visit',
      'integration-page:visit',
      'ndis-notifications-page:visit',
      'budget-page:visit',
      'category-x-page:visit',
      'category-y-page:visit',
      'label-management-page:visit',
      'legal-entity-management-page:visit',
      'account-receivable-page:visit',
      'transactions-page:visit',
      'ar-payments-page:visit',
      'ar-invoices-page:visit',
      'ar-settlement-page:visit',
      'ar-invoice-details-v2-page:visit',
      'ar-invoice-batches-page:visit',
      'ar-payer-statements-page:visit',
      'ar-person-management-page:visit',
      'ar-person-details-page:visit',
      'support-at-home-page:visit',
      'support-at-home-care-recipient-360-page:visit',
      'support-at-home-care-recipients-page:visit',
      'support-at-home-transactions-page:visit',
      'support-at-home-ready-to-claim-page:visit',
      'support-at-home-claims-page:visit',
      'support-at-home-claim-history-page:visit',
      'support-at-home-ready-to-invoice-page:visit',
      'support-at-home-providers-page:visit',
      'support-at-home-pricing-page:visit',
      'support-at-home-budget-page:visit',
      'support-at-home-budget-details-page:visit',
      'support-at-home-statement-page:visit',
      // 'support-at-home-payment-page:visit',
      // 'support-at-home-care-management-page:visit',
      // 'support-at-home-issued-invoices-page:visit',
    ],
  },
  supportAtHome: {
    static: [
      'dashboard-page:visit',
      'setting-page:visit',
      'financial-contact-page:visit',
      'analytics-page:visit',
      'category-x-page:visit',
      'category-y-page:visit',
      'integration-page:visit',
      'label-management-page:visit',
      'legal-entity-management-page:visit',
      'account-receivable-page:visit',
      'transactions-page:visit',
      'ar-payments-page:visit',
      'ar-invoices-page:visit',
      'ar-settlement-page:visit',
      'ar-invoice-details-v2-page:visit',
      'ar-invoice-batches-page:visit',
      'ar-payer-statements-page:visit',
      'ar-person-management-page:visit',
      'ar-person-details-page:visit',
      'support-at-home-page:visit',
      'support-at-home-care-recipient-360-page:visit',
      'support-at-home-care-recipients-page:visit',
      'support-at-home-transactions-page:visit',
      'support-at-home-ready-to-claim-page:visit',
      'support-at-home-claims-page:visit',
      'support-at-home-claim-history-page:visit',
      'support-at-home-ready-to-invoice-page:visit',
      'support-at-home-providers-page:visit',
      'support-at-home-pricing-page:visit',
      'support-at-home-budget-page:visit',
      'support-at-home-budget-details-page:visit',
      'support-at-home-statement-page:visit',
      // 'support-at-home-payment-page:visit',
      // 'support-at-home-care-management-page:visit',
      // 'support-at-home-issued-invoices-page:visit',
    ],
  },
};

// Role-based access control rules
const roleRules = {
  // Example: Users with 'basic' role cannot access admin pages
  basic: {
    denied: ['label-management-page:visit'],
  },
  // Example: Users with 'viewer' role have very limited access
  viewer: {
    denied: [],
  },
  // Example: Users with 'data-entry' role can only access basic pages
  'data-entry': {
    denied: [],
  },
  // Example: Users with 'supervisor' role have access to most pages but not admin settings
  supervisor: {
    denied: [
      'label-management-page:visit',
      'setting-page:visit',
      'integration-page:visit',
      'ndis-notifications-page:visit',
    ],
  },
  admin: {
    denied: [],
  },
  // Add more role-based restrictions as needed
  // 'roleName': {
  //   denied: ['page:action', 'another-page:action'],
  // },
};

export default rules;
export { roleRules };
